import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';

// Initialize Sentry
export const initSentry = () => {
  const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || process.env.SENTRY_DSN;

  if (!SENTRY_DSN) {
    console.warn('Sentry DSN not found. Error tracking will be disabled.');
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.NODE_ENV || 'development',
    release: process.env.REACT_APP_VERSION || 'unknown',
    integrations: [
      new Integrations.BrowserTracing({
        // Capture 100% of transactions for performance monitoring
        // You can reduce this in production
        tracingOrigins: ['localhost', /^https:\/\/yourapi\.domain\.com\/api/],
      }),
    ],

    // Performance monitoring
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,

    // Additional configuration
    beforeSend(event) {
      // Don't send events in development unless explicitly enabled
      if (
        process.env.NODE_ENV === 'development' &&
        !process.env.REACT_APP_SENTRY_DEBUG
      ) {
        return null;
      }
      return event;
    },

    // Set initial tags
    initialScope: {
      tags: {
        component: 'main-app',
      },
    },
  });
};

// Export Sentry for manual error capturing
export { Sentry };

// Helper function to capture user info
export const setSentryUser = user => {
  Sentry.setUser({
    id: user.id,
    email: user.email,
    username: user.email,
    ip_address: '{{auto}}',
  });
};

// Helper function to capture custom errors
export const captureError = (error, context = {}) => {
  Sentry.withScope(scope => {
    Object.keys(context).forEach(key => {
      scope.setTag(key, context[key]);
    });
    Sentry.captureException(error);
  });
};
